import { render, staticRenderFns } from "./CabeceraModalEditarBase.vue?vue&type=template&id=21b1bc66&"
import script from "./CabeceraModalEditarBase.vue?vue&type=script&lang=ts&"
export * from "./CabeceraModalEditarBase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports